// Pure validator for email attachment uploads. Kept module-free so it can be
// tested under node:test without DOM or hook scaffolding.

export const EMAIL_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;

export function validateEmailAttachmentFile(file) {
    if (!file) {
        return { ok: false, reason: 'missing-file', message: 'No file provided.' };
    }
    if (file.size >= EMAIL_ATTACHMENT_MAX_BYTES) {
        return {
            ok: false,
            reason: 'too-large',
            message: 'Attachment must be smaller than 10 MB.'
        };
    }
    return { ok: true };
}
